import intl from "react-intl-universal";
import { reset } from "redux-form";

import * as types from "./types";
import httpService from "../_utils/http-service";
import { fetchFavoriteRestaurants } from "./_favorite-action";
import {
  getAuthHttpConfigByToken,
  getHttpConfig,
  dispatchSignOut,
  getAuthHttpConfig
} from "../_utils/auth-utils";
import { registerCustomerChannel, unregisterCustomerChannel } from "../_utils/socket";
import { traceEvent, reportError } from "../_utils/analytics-utils";


const convertAnonymousOrder = (
  { order, authToken, anonymousToken, callback },
  onSuccess
) => {
  const customerId = order.customers[0].customerId;
  const httpConfig = getAuthHttpConfigByToken(anonymousToken);

  httpService
    .post(
      `/customers/${customerId}/orders/${order.id}/claim`,
      { userToken: authToken },
      httpConfig
    )
    .then(res => {
      if (res.data.statusCode === 200) {
        onSuccess(res.data.data);
      } else {
        callback({ success: false });
        traceEvent("error", "convertAnonymousOrder");
      }
    })
    .catch(err => {
      traceEvent("error", "convertAnonymousOrder");
      callback({ success: false });
    });
};

export const fetchCards = (customerId, authToken, callback) => {
  httpService
    .get(
      // `/v2/customers/${customerId}/card`,
      `/customers/${customerId}/payments/methods`,
      getAuthHttpConfigByToken(authToken)
    )
    .then(res => {
      if (res.data.statusCode === 200) {
        callback({ success: true, cards: res.data.data });
      } else {
        traceEvent("error", "fetchCards");
        callback({ success: false });
      }
    })
    .catch(err => {
      traceEvent("error", "fetchCards");
      callback({ success: false });
    });
};

const dispatchAfterSignInSuccess = ({
  cards,
  profile,
  favorites,
  dispatch
}) => {
  dispatch({
    type: types.SET_ITEM,
    payload: {
      key: "authToken",
      value: profile.authorization
    }
  });

  dispatch({
    type: types.REMOVE_ITEM,
    payload: "anonymousToken"
  });

  dispatch({
    type: types.REMOVE_ITEM,
    payload: "customerName"
  });

  dispatch({
    type: types.REMOVE_ITEM,
    payload: "pushToken"
  });

  dispatch({
    type: types.SET_ITEM,
    payload: {
      key: "favorites",
      value: favorites
    }
  });

  let payload = {
    profile,
    cards
  };

  dispatch({ type: types.SIGN_IN_SUCCCESS, payload });
  dispatch(reset("signin-form"));
};

export const signInSuccess = ({ profile, dispatch, callback, state }) => {
  const authToken = profile.authorization;
  const { order, storage } = state;

  fetchCards(profile.customer.id, authToken, res => {
    if (res.success === true) {
      fetchFavoriteRestaurants(profile.customer.id, authToken, response => {
        if (response.success === true) {
          const favorites = response.list;
          console.log(res, 'res', res.cards, res.cards.affipayPaymentMethods)
          const cards = res.cards.affipayPaymentMethods;
          console.log(cards, 'cards')
          if (order.orderStatus === "draft") {
            const anonymousToken = storage.anonymousToken;

            convertAnonymousOrder(
              { order, authToken, anonymousToken, callback },
              order1 => {
                dispatch({
                  type: types.SET_ORDER,
                  payload: order1
                });

                dispatchAfterSignInSuccess({
                  cards,
                  profile,
                  favorites,
                  dispatch
                });
                callback({
                  success: true,
                  profile
                });
                registerCustomerChannel(profile.customer.id);
              }
            );
            return;
          }

          dispatchAfterSignInSuccess({ cards, profile, favorites, dispatch });
          registerCustomerChannel(profile.customer.id);
          callback({ success: true, profile });
        } else {
          traceEvent("error", "signInSuccess");
          callback({ success: false });
        }
      });
    } else {
      traceEvent("error", "signInSuccess");
      callback({ success: false });
    }
  });
};

export const signin = (account, callback) => {
  return function(dispatch, getState) {
    httpService
      .post("/customers/login", account, getHttpConfig())
      .then(res => {
        if (res.data.statusCode === 200) {
          const profile = res.data.data;
          signInSuccess({ profile, dispatch, callback, state: getState() });
        } else {
          reportError("signin", {res});
          callback({ success: false });
        }
      })
      .catch(err => {
        reportError("signin", {err});
        callback({ success: false });
      });
  };
};

export const signout = () => {
  return async function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .put("/customers/logout", null, getAuthHttpConfig(storage))
      .then(res => {
        const auth =  getState().auth;
        unregisterCustomerChannel(auth.profile.customer.id);
        dispatchSignOut(dispatch);
      })
      .catch(err => {
        traceEvent("error", "signout");
        dispatchSignOut(dispatch);
      });
  };
};

export const clearAnonymousToken = () => {
  return { type: types.REMOVE_ITEM, payload: "anonymousToken" };
};



export const signup = (signupData, callback) => {
  return async function(dispatch, getState) {
    if (signupData.referralCode !== undefined) {
      var res = await httpService.get(
        `/referrals/verify?referralCode=${signupData.referralCode}`
      );

      if (res.data.statusCode !== 200) {
        callback({
          success: false,
          message: intl.get("signup.referralCode.invalidText")
        });

        traceEvent("error", "signup");
        return;
      }
    }

    httpService
      .post("customers/register", signupData, getHttpConfig())
      .then(res => {
      
        if (res.data.statusCode !== 200) {
          if (res.data.message === "Phone number exists already") {
            callback({
              sucess: false,
              message: intl.get("emailSignup.phoneNumberExists")
            });
          } else {
            traceEvent("error", "signup");
            callback({ sucess: false, message: res.data.message });
          }
        } else {
          const profile = res.data.data;
          signInSuccess({ profile, dispatch, callback, state: getState() });
        }
      })
      .catch(err => {
        traceEvent("error", "signup");
        callback({ success: false, message: intl.get("general.serverError") });
      });
  };
};
